export const TransactionStep = {
  Amount: 'AMOUNT',
  Payer: 'PAYER',
  TransactionSuccess: 'TRANSACTION_SUCCESS',
}
